const regioes = [
  { nome: 'Zona Sul', bairros: ['Moema', 'Brooklin', 'Vila Mariana', 'Jardins', 'Itaim Bibi', 'Campo Belo', 'Vila Olímpia', 'Pinheiros'] },
  { nome: 'Zona Oeste', bairros: ['Butantã', 'Morumbi', 'Vila Sônia', 'Raposo Tavares', 'Jaguaré', 'Rio Pequeno'] },
  { nome: 'Zona Norte', bairros: ['Santana', 'Tucuruvi', 'Limão', 'Lapa', 'Casa Verde', 'Barra Funda'] },
  { nome: 'Zona Leste', bairros: ['Tatuapé', 'Anália Franco', 'Vila Formosa', 'Carrão', 'Aricanduva'] },
  { nome: 'Centro', bairros: ['Centro Histórico', 'Bela Vista', 'Consolação', 'Liberdade', 'Sé'] },
  { nome: 'Grande SP', bairros: ['Guarulhos', 'Osasco', 'Santo André', 'São Bernardo', 'São Caetano', 'Taboão da Serra', 'Diadema'] },
];

export default function RegioesAtendidas() {
  return (
    <section className="py-16 md:py-24 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-12">
          <span className="inline-block text-xs font-bold tracking-widest text-primary-600 uppercase mb-3">
            ATENDIMENTO EM TODA A CIDADE
          </span>
          <h2 className="text-3xl md:text-4xl font-bold text-foreground-950 leading-tight">
            Envidraçamento de Sacada em São Paulo e Grande SP
          </h2>
          <p className="text-foreground-600 mt-3 text-sm max-w-2xl mx-auto">
            Atendemos todos os bairros de São Paulo capital e região metropolitana com equipe própria de instalação. Desde a Zona Sul até o Grande ABC.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {regioes.map((regiao) => (
            <div
              key={regiao.nome}
              className="bg-background-50 border border-background-200/70 rounded-xl p-5 hover:border-primary-300 transition-all duration-200"
            >
              <div className="flex items-center gap-2 mb-3">
                <div className="w-8 h-8 flex items-center justify-center rounded-full bg-primary-100 text-primary-600">
                  <i className="ri-map-pin-2-line text-sm"></i>
                </div>
                <h3 className="font-bold text-foreground-900 text-sm">{regiao.nome}</h3>
              </div>
              <div className="flex flex-wrap gap-2">
                {regiao.bairros.map((bairro) => (
                  <span
                    key={bairro}
                    className="inline-flex items-center px-2.5 py-1 rounded-full bg-secondary-100 text-secondary-900 text-xs font-medium"
                  >
                    {bairro}
                  </span>
                ))}
              </div>
            </div>
          ))}
        </div>

        <div className="mt-10 text-center">
          <p className="text-foreground-500 text-sm mb-4">
            Não encontrou seu bairro? Entre em contato — atendemos toda a Grande São Paulo.
          </p>
          <a
            href="https://wa.me/5511986765185?text=Ol%C3%A1%2C%20gostaria%20de%20saber%20se%20atendem%20na%20minha%20regi%C3%A3o."
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 bg-green-500 hover:bg-green-600 text-white font-bold px-6 py-3 rounded-full text-sm transition-all duration-200 whitespace-nowrap cursor-pointer"
          >
            <div className="w-5 h-5 flex items-center justify-center">
              <i className="ri-whatsapp-line text-lg"></i>
            </div>
            Verificar Atendimento na Minha Região
          </a>
        </div>
      </div>
    </section>
  );
}